<div class="modal__header">
	<div class="modal__header-actions header-actions--mobile">
		<button [attr.aria-label]="'modals.datePicker.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'modals.datePicker.alt.arrowLeft' | ibeadmin | async"></app-svg>
		</button>
	</div>
	<div class="title_wrapper">
		<h2 class="title" id="modal__title">{{ 'modals.datePicker.text.selectDate' | ibeadmin | async }}</h2>
	</div>
	<div class="modal__header-actions header-actions">
		<button [attr.aria-label]="'modals.datePicker.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'modals.datePicker.alt.arrowLeft' | ibeadmin | async"></app-svg>
		</button>
	</div>
</div>

<div class="modal__body select-themes-body sl--scrollable">

	<!-- <select (change)="TAP_changeMonth($event.target.value)" class="select-month">
		<option *ngFor="let option of optionsMonth" [value]="option.value" [selected]="defMonth === option.value">{{option.label}}</option>
	</select> -->

	<div class="month-switcher-bar">
		<div class="month-switcher-bar__container container">
			<button class="month-switcher-arrow arrow-back" [attr.aria-label]="'modals.datePicker.aria.goToPrevMonth' | ibeadmin | async" [ngClass]="{ 'disabled': !TAP_findIndexMonth() }" (click)="TAP_handleMoveBack()">
				<app-svg svg="icons.svg#general--arrow--left"></app-svg>
			</button>
			<div #monthScroll class="month-switcher-bar__content">
				<ul class="month-list">
					<li entry *ngFor="let month of optionsMonth; let i = index" class="month-entry" [ngClass]="{'is-selected' : defMonthIndex === i}">
						<span class="month-descriptor">{{ month.label | titlecase }}</span>
					</li>
				</ul>
			</div>
			<button class="month-switcher-arrow arrow-forward" [attr.aria-label]="'modals.datePicker.aria.goToNextMonth' | ibeadmin | async" [ngClass]="{ 'disabled': TAP_findIndexMonth() == (optionsMonth.length - 1) }" (click)="TAP_handleMoveForward()">
				<app-svg svg="icons.svg#general--arrow--right"></app-svg>
			</button>
		</div>
	</div>

	<div class="datepicker-wrapper--modal">
		<my-date-picker class="datepicker--modal" id="datepicker-modal" [options]="datepickerOptions" (calendarViewChanged)="calendarViewChanged($event)" [selector]="datepickerSelector" (calendarToggle)="calendarToggle($event)" (dateChanged)="onDateChanged($event)" [defaultMonth]="defMonth" [(ngModel)]="myDateModel"></my-date-picker>
	</div>
</div>
